import "./DotMenu.scss";

const DotMenu = () => {
  return (
    <div className="dot-menu-container">
      <span className="dot"></span>
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
  );
};

export default DotMenu;
